import React, { memo } from 'react';
import styles from './TaskItem.module.css';
import { ProgressBar } from '../../../../Components/ProgressBar/ProgressBar';
import { TaskButton, TaskButtonVariant } from '../../../../Components/TaskButton/TaskButton';
import { useAdaptiveText } from '../../../../hooks/useAdaptiveText';
import { Reward } from '../../../../Components/Reward/Reward';
import { TaskItemProps } from './TaskItemBase';

export const CombinedTaskItem: React.FC<TaskItemProps> = memo(({ task, onTaskAction }) => {
  const { measureRef } = useAdaptiveText({
    maxWidthAtLargeScreen: 250,
    maxWidthAtSmallScreen: 150,
    largeScreenWidth: 500,
    smallScreenWidth: 360
  });

  console.log('🎯 CombinedTaskItem rendering with task:', task.id);
  console.log('🎯 CombinedTaskItem rendering with task:', task);

  const getButtonProps = () => {
    console.log('🔄 Getting button props for status:', task.status);
    const baseProps = {
      variant: task.status as TaskButtonVariant,
      text: 'Выполнить',
      task,
      onClick: onTaskAction ? () => onTaskAction(Number(task.id)) : undefined
    };

    switch (task.status) {
      case 'CLAIMED':
          return {
            ...baseProps,
            variant: 'CLAIMED' as TaskButtonVariant,
            text: 'Выполнено',
          };
      case 'DONE':
          return {
            ...baseProps,
            variant: 'CLAIMED' as TaskButtonVariant,
            text: 'Выполнено',
          };

      case 'NOT_STARTED':
        if (task.link && task.link !== '') {
          return {
            ...baseProps,
            variant: 'CLAIMED_WITH_LINK' as TaskButtonVariant,
            text: task.buttonText || 'Выполнить',
            link: task.link,
          };
        } else {
          return {
            ...baseProps,
            text: task.buttonText || 'Выполнить',
          };
        }
      case 'IN_PROGRESS':
        if (task.link && task.link !== '') {
          return {
            ...baseProps,
            variant: 'CLAIMED_WITH_LINK' as TaskButtonVariant,
            text: '',
            link: task.link,
          };
        } else {
          return {
            ...baseProps,
            text: 'Продолжить',
          };
        }
      default:
        return baseProps;
    }
  };

  // Стили для комбинированных заданий
  const combinedTaskStyles = {
    taskItem: `${styles.taskItem} ${styles.combinedTaskItem}`,
    cardContent: `${styles.cardContent} ${styles.combinedCardContent}`,
    taskTitle: `${styles.taskTitle} ${styles.combinedTaskTitle}`,
    cardImage: `${styles.cardImage} ${styles.combinedCardImage}`,
    icon: `${styles.icon} ${styles.combinedIcon}`,
  };

  const handleTaskAction = () => {
    if (task.link && task.link !== '') {
      window.Telegram.WebApp.openTelegramLink(task.link);
    }
  };

  const showTaskButton = (task.status === 'DONE' || task.status === 'CLAIMED') || 
                        (task.link !== '' && task.link !== null);

  return (
    <div className={combinedTaskStyles.taskItem} onClick={handleTaskAction}>
      <span ref={measureRef} style={{ visibility: 'hidden', position: 'absolute' }} />
      
      <div className={combinedTaskStyles.cardContent}>
        <div className={combinedTaskStyles.cardImage}>
          <img 
            src={task.icon} 
            alt={task.title} 
            className={combinedTaskStyles.icon} 
          />
        </div>
        <div className={styles.taskContent}>
          <h4 className={combinedTaskStyles.taskTitle} title={task.title}>
            {task.title}
          </h4>
          <div className={styles.rewards}>
            <Reward type="dc" amount={task.rewards?.dc ?? 0} />
            <Reward type="ticket" amount={task.rewards?.tickets ?? 0} />
          </div>
        </div>
      </div>
      
      {task.status !== 'CLAIMED' && task.status !== 'DONE' && task.progress?.total && task.link === '' && (
        <ProgressBar
          current={task.progress.current}
          total={task.progress.total}
          showText={true}
          showProgress={false}
        />
      )}
      {showTaskButton && (
        <TaskButton {...getButtonProps()} />
      )}
    </div>
  );
}, (prevProps, nextProps) => {
  return prevProps.task.id === nextProps.task.id && 
         prevProps.task.status === nextProps.task.status;
}); 